import { IconActionAttention } from '@cko/icons';
import styled from 'styled-components';

export const IconBox = styled.div`
  background-color: var(--control-bg-warn-decorative);
  border-radius: var(--border-r-seed);
  margin-bottom: var(--layout-shoe);
  padding: var(--layout-stamp);
`;

export const AlertIcon = styled(IconActionAttention)`
  g {
    fill: var(--control-icon-warn);
  }
`;
